module.exports = __webpack_public_path__ + "static/media/badge.57da49bc.svg";